import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { UserService } from '@sharedcommon/services/user.service';

@Injectable()
export class RightsGuard implements CanActivateChild {

    constructor(private userService: UserService) { }

    canActivateChild(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        if (route.data['rights']) {
            const rights = route.data['rights'] as Array<string>;
            return this.userService.hasRights(rights);
        }
        return true;
    }

}
